import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NewsRoutes } from './news.routes';

/**
 * Services
 */
import { NewsListsResolver, NewsItemResolver } from '../news.resolver';
import { NewsService } from '../news.service';

/**
 * Components
 */
import { NewsListsComponent } from './news-lists/news-lists.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { NewsCrudComponent } from './news-crud/news-crud.component';

/**
 * Shared
 */
import { BreadcrumbsModule } from '@app/shared/breadcrumbs/breadcrumbs.module';
import { NewsItemModule } from '@app/shared/news-item/news-item.module';

/**
 * Vendors
 */
import { MenuModule } from 'primeng/menu';
import { NgxPaginationModule } from 'ngx-pagination';
import { SkeletonModule } from 'primeng/skeleton';
import { RippleModule } from 'primeng/ripple';

/**
 * Wysiwyg
 */
import { QuillModule } from 'ngx-quill';


@NgModule({
  declarations: [
    NewsListsComponent,
    NewsDetailComponent,
    NewsCrudComponent
  ],
  exports: [
    NewsListsComponent,
    NewsDetailComponent,
    NewsCrudComponent
  ],
  imports: [
    RouterModule.forChild(NewsRoutes),
    CommonModule,
    ReactiveFormsModule,
    BreadcrumbsModule,
    NewsItemModule,
    MenuModule,
    NgxPaginationModule,
    SkeletonModule,
    QuillModule.forRoot(),
    RippleModule
  ],
  providers: [
    NewsListsResolver,
    NewsItemResolver,
    NewsService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class NewsModule {}
